export default "/images/tablet.svg?0f2be4c25c9f9e15c35e1845cfa5ce1b";